<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group
            label="Desde"
            label-for="fechaDesde"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaDesde" 
              v-model= "filtro.fechaDesde" 
              type="date">
            </b-form-input>
          </b-form-group>
          <b-form-group
            label="Hasta"
            label-for="fechaHasta"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaHasta" 
              v-model= "filtro.fechaHasta" 
              type="date">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Personal"
            label-for="personal"
            :label-cols="labelCols"
            horizontal>
            <b-input-group>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="seleccionarPersonal">
                <b-input-group-text>
                  <i :class="{ 'fa fa-search': !filtro.personal,
                                'fa fa-remove': filtro.personal  }"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="personal"
                :value="personalNombre"
                readonly
                type="text"/>
            </b-input-group>
          </b-form-group>

          <app-ingreso-egreso-tipo
            label="Tipo"
            labelOption="Todos los tipos de movimiento"
            :label-cols="labelCols"
            :nombre="ingresoEgresoTipoNombre"
            :lista="ingresosEgresosTiposList"
            :nullDisabled="false"
            @updated="ingresoEgresoTipoActualizado">
          </app-ingreso-egreso-tipo>  
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>  

    <b-modal ref="searchPersonalModal" 
        title="Seleccionar Personal"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="personal-search-modal">
      <app-search-personal
        @personalSeleccionado="personalSeleccionado">
      </app-search-personal>  
    </b-modal>
  </div>
</template>

<script>
import SearchPersonal from '../personal/SearchList.vue'
import IngresoEgresoTipo from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  components: {
    appSearchPersonal: SearchPersonal,
    appIngresoEgresoTipo: IngresoEgresoTipo,
  },
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    personal: {
      type: Object,
      default: null
    },
    ingresoEgresoTipo: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        personal: null,
        ingresoEgresoTipo: null
      },

      ingresosEgresosTipos: [],
      ingresosEgresosTiposList: [],

      showOpcionesFiltro: Boolean(false),
      labelCols: 2
    }
  },
  created() {
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.personal = this.personal;
      this.filtro.ingresoEgresoTipo = this.ingresoEgresoTipo;

      this.$store.dispatch('ingresosegresostipos/getList')
        .then(() => {
          this.ingresosEgresosTipos = this.$store.getters['ingresosegresostipos/list'];
          this.ingresosEgresosTiposList = this.$store.getters['ingresosegresostipos/selectList'];
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de movimiento.'));
  },
  computed: {
    personalNombre() {
      if (this.filtro.personal) {
        if (this.filtro.personal.nombre) {
          return this.filtro.personal.nombre.trim();
        }
      }
      return '';
    },
    ingresoEgresoTipoNombre() {
      if (this.filtro.ingresoEgresoTipo) {
        if (this.filtro.ingresoEgresoTipo.nombre) {
          return this.filtro.ingresoEgresoTipo.nombre.trim();
        }
      }
      return null;
    }
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.personal = null;
      this.filtro.ingresoEgresoTipo = null;
    },
    seleccionarPersonal() {
      if (this.filtro.personal) {
        this.filtro.personal = null;
      } else {
        this.$refs.searchPersonalModal.show();
      }
    },
    personalSeleccionado(item) {
      this.$refs.searchPersonalModal.hide();
      this.filtro.personal = item;
    },
    ingresoEgresoTipoActualizado(nombre) {
      if (this.ingresoEgresoTipoNombre != nombre) {
        let ingresoEgresoTipo;
        if (nombre) {
          ingresoEgresoTipo = this.getSelected(this.ingresosEgresosTipos, nombre);
        }

        this.filtro.ingresoEgresoTipo = ingresoEgresoTipo;
      }
    },
  },
}
</script>

<style>
</style>
